/*
 * ELTANE — header state controller
 *
 * Two responsibilities only:
 *   1. Publish the rendered height of the header group as --eltane-header-offset
 *      so overlay sections (hero, collection hero) can pull themselves up by
 *      exactly the right amount without magic numbers.
 *   2. Toggle .eltane-header-scrolled on <html> so CSS can swap the header
 *      from transparent to frosted.
 *
 * Dawn's <sticky-header> still owns the sticky/hide behaviour.
 */
(function () {
  'use strict';

  var SCROLL_THRESHOLD = 24;
  var root = document.documentElement;
  var ticking = false;

  function headerGroupElements() {
    return document.querySelectorAll('.shopify-section-group-header-group');
  }

  function measure() {
    var offset = 0;

    headerGroupElements().forEach(function (section) {
      offset += section.offsetHeight;
    });

    root.style.setProperty('--eltane-header-offset', offset + 'px');
  }

  function applyScrollState() {
    var scrolled = (window.scrollY || window.pageYOffset) > SCROLL_THRESHOLD;
    root.classList.toggle('eltane-header-scrolled', scrolled);
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(applyScrollState);
  }

  function init() {
    measure();
    applyScrollState();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure, { passive: true });

    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(measure);
      headerGroupElements().forEach(function (section) {
        observer.observe(section);
      });
    }

    // Re-measure when the theme editor swaps header blocks in and out.
    document.addEventListener('shopify:section:load', measure);
    document.addEventListener('shopify:section:unload', measure);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
